import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconSortUp = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M7.4866 13.1724L10.9487 9.85563V18H13.0513V9.85563L16.5134 13.1724L18 11.7482L12 6L6 11.7482L7.4866 13.1724Z", clipRule: "evenodd" }) }));
const Memo = memo(SvgIconSortUp);
export default Memo;
//# sourceMappingURL=IconSortUp.js.map